import { useEffect, useState } from 'react';

/**
 * Zählt `seconds` sekündlich herunter, bis 0. Wird `seconds` neu gesetzt,
 * startet der Countdown neu. Rückgabe ist die aktuelle Restsekunden-Zahl
 * — oder `null`, wenn kein Countdown läuft.
 *
 * Nutzung:
 *   const remaining = useRetryCountdown(error?.retryAfterSeconds ?? null);
 *   return remaining ? <p>Nächster Versuch in {remaining}s möglich.</p> : null;
 */
export function useRetryCountdown(seconds: number | null | undefined): number | null {
  const [remaining, setRemaining] = useState<number | null>(
    seconds ?? null,
  );

  useEffect(() => {
    if (seconds === null || seconds === undefined) {
      setRemaining(null);
      return;
    }
    setRemaining(seconds);
    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev === null || prev <= 1) {
          clearInterval(interval);
          return prev === null ? null : 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);

  return remaining;
}
